<template>
  <div>
    <user-detail-title
      first-bread="供应商"
      second-bread="供应商查看"
      first-url="/user/supply"
      title-name="供应商查看"
    ></user-detail-title>
    <user-detail-base style="height: 81vh;"
    >
      <el-form label-position="left" label-width="100px" v-if="LookData">
        <el-form-item label="公司名称">
          <p>{{ LookData.companyName }}</p>
        </el-form-item>
        <el-form-item label="logo图片">
          <el-image class="item-image" :src="'http://'+LookData.logoUrl" alt=""></el-image>
        </el-form-item>
        <el-form-item label="背景颜色">
          <el-color-picker v-model="LookData.colour" show-alpha disabled></el-color-picker>
        </el-form-item>
      </el-form>
    </user-detail-base>
  </div>
</template>

<script>
  import UserDetailTitle from "../Common/UserDetailTitle";
  import UserDetailBase from "../Common/UserDetailBase";
  export default {
    name: "SupplyLook",
    components: {UserDetailBase, UserDetailTitle},
    data(){
      return{
        LookData:null,
      }
    },
    created() {
      this.GetLookData(this.$route.params.id)
    },
    methods:{
      GetLookData(id){
        this.$axios.get('/api/supplier/getById/'+id).then(res=>{
          this.LookData=res.data.data
        })
      }
    }
  }
</script>

<style scoped>

</style>